import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["isArray", "start", "className", "render"],
  _excluded2 = ["style", "render"],
  _excluded3 = ["value", "keyName", "className", "displayDataTypes", "components", "displayObjectSize", "enableClipboard", "highlightUpdates", "objectSortKeys", "indentWidth", "collapsed", "level", "keyid", "quotes", "onCopied", "onExpand"];
import { Fragment, useId, cloneElement, useState } from 'react';
import { ValueView, Colon, Label, Line, typeMap } from './value';
import { TriangleArrow } from './arrow/TriangleArrow';
import { useExpandsStatus, store } from './store';
import { Copied } from './copied';
import { Semicolon } from './semicolon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Meta(props) {
  var {
      isArray = false,
      start = false,
      className,
      render
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var mark = isArray ? '[]' : '{}';
  var cls = "w-rjv-" + (isArray ? 'brackets' : 'curlybraces') + "-" + (start ? 'start' : 'end') + " " + (className || '');
  var color = "var(--w-rjv-" + (isArray ? 'brackets' : 'curlybraces') + "-color, #236a7c)";
  if (render) return render(_extends({
    isArray,
    className: cls,
    style: {
      color
    },
    children: start ? mark.charAt(0) : mark.charAt(1)
  }, reset));
  return /*#__PURE__*/_jsx(Label, _extends({
    color: color,
    className: cls
  }, reset, {
    children: start ? mark.charAt(0) : mark.charAt(1)
  }));
}
export var Ellipsis = _ref => {
  var {
      style,
      render
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded2);
  var styl = _extends({
    cursor: 'pointer'
  }, style);
  var className = "w-rjv-ellipsis " + (props.className || '');
  if (render) return render(_extends({
    style: styl
  }, props, {
    className
  }));
  return /*#__PURE__*/_jsx("span", _extends({
    className: className,
    style: styl
  }, props, {
    children: "..."
  }));
};
export var CountInfo = _ref2 => {
  var {
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(Label, {
    style: {
      paddingLeft: 4,
      fontStyle: 'italic'
    },
    color: "var(--w-rjv-info-color, #0000004d)",
    className: "w-rjv-object-size",
    children: children
  });
};
export function RooNode(props) {
  var _expands$keyid;
  var {
      value = {},
      keyName,
      className,
      displayDataTypes = true,
      components = {},
      displayObjectSize = true,
      enableClipboard = true,
      highlightUpdates = true,
      objectSortKeys = false,
      indentWidth = 15,
      collapsed,
      level = 1,
      keyid = 'root',
      quotes = '"',
      onCopied,
      onExpand
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded3);
  var isArray = Array.isArray(value);
  var subkeyid = useId();
  var expands = useExpandsStatus();
  var expand = (_expands$keyid = expands[keyid]) != null ? _expands$keyid : typeof collapsed === 'boolean' ? collapsed : typeof collapsed === 'number' ? level <= collapsed : true;
  var arrowStyle = {
    transform: "rotate(" + (expand ? '0' : '-90') + "deg)",
    transition: 'all 0.3s'
  };
  var handle = () => {
    onExpand && typeof onExpand === 'function' && onExpand({
      expand: !expand,
      keyid,
      keyName,
      value: value
    });
    !expand ? store.expand(keyid) : store.collapse(keyid);
  };
  var subNodeProps = {
    components,
    indentWidth,
    displayDataTypes,
    displayObjectSize,
    enableClipboard,
    highlightUpdates,
    onCopied,
    onExpand,
    collapsed,
    quotes,
    level: level + 1,
    style: {
      paddingLeft: indentWidth
    }
  };
  var valueViewProps = {
    displayDataTypes,
    displayObjectSize,
    enableClipboard,
    indentWidth,
    renderBraces: components.braces,
    renderValue: components.value
  };
  var arrowView = components.arrow ? /*#__PURE__*/cloneElement(components.arrow, {
    style: arrowStyle,
    'data-expand': expand,
    className: "w-rjv-arrow"
  }) : /*#__PURE__*/_jsx(TriangleArrow, {
    style: arrowStyle,
    className: "w-rjv-arrow"
  });
  var [showTools, setShowTools] = useState(false);
  var tools = enableClipboard ? /*#__PURE__*/_jsx(Copied, {
    show: showTools,
    text: value,
    onCopied: onCopied,
    render: components.copied
  }) : undefined;
  var eventProps = {};
  if (enableClipboard) {
    eventProps.onMouseEnter = () => setShowTools(true);
    eventProps.onMouseLeave = () => setShowTools(false);
  }
  var nameKeys = isArray ? Object.keys(value).map(m => Number(m)) : Object.keys(value);

  // object
  var entries = isArray ? Object.entries(value).map(m => [Number(m[0]), m[1]]) : Object.entries(value);
  if (objectSortKeys) {
    entries = objectSortKeys === true ? entries.sort((_ref3, _ref4) => {
      var [a] = _ref3;
      var [b] = _ref4;
      return typeof a === 'string' && typeof b === 'string' ? a.localeCompare(b) : 0;
    }) : entries.sort((_ref5, _ref6) => {
      var [a] = _ref5;
      var [b] = _ref6;
      return typeof a === 'string' && typeof b === 'string' ? objectSortKeys(a, b) : 0;
    });
  }
  return /*#__PURE__*/_jsxs("div", _extends({}, reset, {
    className: className + " w-rjv-inner"
  }, eventProps, {
    children: [/*#__PURE__*/_jsxs(Line, {
      style: {
        display: 'inline-flex',
        alignItems: 'center'
      },
      onClick: handle,
      children: [arrowView, (typeof keyName === 'string' || typeof keyName === 'number') && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(Semicolon, {
          value: value,
          quotes: quotes,
          render: components.objectKey,
          color: typeof keyName === 'number' ? typeMap['number'].color : '',
          show: typeof keyName === 'string',
          children: keyName
        }), /*#__PURE__*/_jsx(Colon, {})]
      }), /*#__PURE__*/_jsx(Meta, {
        start: true,
        isArray: isArray,
        render: components.braces
      }), !expand && /*#__PURE__*/_jsx(Ellipsis, {
        render: components.ellipsis
      }), !expand && /*#__PURE__*/_jsx(Meta, {
        isArray: isArray,
        render: components.braces
      }), displayObjectSize && /*#__PURE__*/_jsxs(CountInfo, {
        children: [nameKeys.length, " items"]
      }), tools]
    }), expand && /*#__PURE__*/_jsx(Line, {
      className: "w-rjv-content",
      style: {
        borderLeft: 'var(--w-rjv-border-left-width, 1px) solid var(--w-rjv-line-color, #ebebeb)',
        marginLeft: 6
      },
      children: entries.length > 0 && entries.map((_ref7, idx) => {
        var [key, itemVal] = _ref7;
        var item = itemVal;
        var renderKey = /*#__PURE__*/_jsx(Semicolon, {
          value: item,
          quotes: quotes,
          highlightUpdates: highlightUpdates,
          render: components.objectKey,
          color: typeof key === 'number' ? typeMap['number'].color : '',
          show: typeof key === 'string',
          children: key
        });
        var isEmpty = Array.isArray(item) && item.length === 0 || typeof item === 'object' && item && !(item instanceof Date) && Object.keys(item).length === 0;
        if (Array.isArray(item) && !isEmpty) {
          var label = isArray ? idx : key;
          return /*#__PURE__*/_jsx(Line, {
            className: "w-rjv-wrap",
            children: /*#__PURE__*/_jsx(RooNode, _extends({
              value: item,
              keyid: keyid + subkeyid + label,
              keyName: label
            }, subNodeProps))
          }, label + idx);
        }
        if (typeof item === 'object' && item && !(item instanceof Date) && !isEmpty) {
          return /*#__PURE__*/_jsx(Line, {
            className: "w-rjv-wrap",
            children: /*#__PURE__*/_jsx(RooNode, _extends({
              keyid: keyid + subkeyid + key,
              value: item,
              keyName: key
            }, subNodeProps))
          }, key + '' + idx);
        }
        if (typeof item === 'function') {
          return;
        }
        return /*#__PURE__*/_jsx(ValueView, _extends({}, valueViewProps, {
          renderKey: renderKey,
          keyName: key,
          value: item
        }), idx);
      })
    }), expand && /*#__PURE__*/_jsx(Line, {
      style: {
        paddingLeft: 2
      },
      children: /*#__PURE__*/_jsx(Meta, {
        render: components.braces,
        isArray: isArray,
        style: {
          paddingLeft: 2,
          display: 'inline-block'
        }
      })
    })]
  }));
}